<p-dialog [(visible)]="displaySearchDialog" [modal]="true" [style]="{width: '65vw'}" (onHide)="cancelSearch()">
  <ng-template pTemplate="header">
    <div class="title-search">
      Select Account
    </div>
  </ng-template>
  <app-account-filter
    [accountFilter]="accountFilter"
    [isFilterAccount]="isFilterAccount"
    [isForeignCurrencyAccount]="isForeignCurrencyAccount"
    [currency]="currency"
    (submit)="triggerFilterAccount($event)"
    (cancel)="resetFilterAccount()">

  </app-account-filter>
  <div class="flex justify-content-between">
    <div class="formgrid grid w-70">
      <div class="mt-3 w-100">
        <div class="row">
          <div class="col">
            <div class="accounts font-13">
              @if (!isFilterAccount) {
                <app-user-account-list
                  [selectedAccount]="selectedAccount"
                  [loadAccount]="loadAccount"
                  [allowSelectAccountType]="allowSelectAccountType"
                  [currency]="currency"
                  (addAccount)="addAccount($event)"
                  (deleteAccountFromList)="removeAccount()"
                  (addAccountType)="addAccountType($event)"
                  [kindOfAccountType]="kindOfAccountType"
                  [isForeignCurrencyAccount]="isForeignCurrencyAccount"
                  [hideClosedAccount]="hideClosedAccount">
                </app-user-account-list>
              }
              @if (isFilterAccount) {
                <app-user-account-list-table
                  [accountFilter]="accountFilter"
                  [selectedAccount]="selectedAccount"
                  [currency]="currency"
                  (addAccount)="addAccount($event)"
                  [kindOfAccountType]="kindOfAccountType"
                  [isForeignCurrencyAccount]="isForeignCurrencyAccount"
                  [hideClosedAccount]="hideClosedAccount">
                </app-user-account-list-table>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w-30 mr-5 mt-20">
      @if (getSelectedAccount()?.number) {
        <div class="account-wrapper">
          <div class="account-group-act">
            <div class="account-info">
              <div class="account-info1">
                <span>{{getSelectedAccount()?.number}}</span>
              </div>
            </div>
            <div class="account-action">
              <em class="pi pi-times delete-icon" style="cursor: pointer;"
              (click)="deleteSelectedAccount()"></em>
            </div>
          </div>
        </div>
      }
      @if (getSelectedAccount()?.code) {
        <div class="account-wrapper">
          <div class="account-group-act">
            <div class="account-info">
              <div class="account-info1">
                <span>{{getSelectedAccount()?.code}}</span>
                @if (getSelectedAccount()?.name) {
                  <span>{{"- " + getSelectedAccount()?.name}}</span>
                }
              </div>
            </div>
            <div class="account-action">
              <em class="pi pi-times delete-icon" style="cursor: pointer;"
              (click)="deleteSelectedAccount()"></em>
            </div>
          </div>
        </div>
      }
      <div class="formgrid grid justify-content-center">
        <div class="field mt-6 flex">
          <app-button id="account-select-ok" buttonClass="btn-primary" buttonType="button"
            (clickEvent)="onSelect()">
            <span translate>buttons.ok</span>
          </app-button>
          <app-button id="account-select-cancel" buttonClass="btn-secondary mr-0" buttonType="button"
            (clickEvent)="cancelSearch()">
            <span translate>buttons.cancel</span>
          </app-button>

        </div>
      </div>
    </div>
  </div>
</p-dialog>